import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainNavigationComponent } from '@ace/ace';
import { AuthserviceService } from './core/guard/authservice.service';

const routes: Routes = [
  {
    path: "login",
    loadChildren: () =>
      import("@ace/ace").then(
        (m) => m.LoginModule,
      )
  },
  {
    path: 'forgot-password',
    loadChildren: () =>
      import("@ace/ace").then(
        (m) => m.ForgotPasswordModule,
      )
  },
  {
    path: 'reset-password',
    loadChildren: () => 
      import("@ace/ace").then(
        (m) => m.ResetPasswordModule
      )
  },
  {
    path: 'trending-topics',
    redirectTo: 'main/trending-topics',
    pathMatch: 'full'
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'main',
    component: MainNavigationComponent,
    children: [
      {
        path: 'smtp-configuration',
        loadChildren: () =>
          import('@ace/ace').then(
            (m) => m.SmtpConfigurationModule
          ),
      },
      {
        path: 'landing-page',
        loadChildren: () =>
          import("./layouts/landing-page/landing-page.module").then(
            (m) => m.LandingPageModule,
          )
      },
      {
        path: 'reported-messages',
        loadChildren: () =>
          import("./layouts/reported-messages/reported-messages.module").then(
            (m) => m.ReportedMessagesModule,
          )
      },
      {
        path: 'web-search',
        loadChildren: () =>
          import("./layouts/web-search/web-search.module").then(
            (m) => m.WebSearchModule,
          )
      },
      {
        path: 'user-experience',
        loadChildren: () =>
          import("./layouts/user-experience/user-experience.module").then(
            (m) => m.UserExperienceModule,
          )
      },
      {
        path: 'chatbot-interactions',
        loadChildren: () =>
          import("./layouts/chatbot-interactions/chatbot-interactions.module").then(
            (m) => m.ChatbotInteractionsModule,
          )
      },
      {
        path: 'trending-topics',
        loadChildren: () =>
          import("./layouts/trending-topics/trending-topics.module").then(
            (m) => m.TrendingTopicsModule,
          )
      },
      {
        path: 'quizzes',
        loadChildren: () =>
          import("./layouts/quizzes/quizzes.module").then(
            (m) => m.QuizzesModule,
          )
      },
      {
        path: 'master-management-v2',
        loadChildren: () =>
          import("@ace/ace").then(
            (m) => m.MasterManagementV2Module,
          )
      },
      {
        path: "user-management",
        loadChildren: () =>
          import("@ace/ace").then(
            (m) => m.UserManagementModule,
          )
      },
      {
        path: 'chatbot-configuration',
        loadChildren: () =>
          import("./layouts/chatbot-configuration/chatbot-configuration.module").then(
            (m) => m.ChatbotConfigurationModule,
          )
      },
      {
        path: 'noise-management',
        loadChildren: () =>
          import('./layouts/noise-management/noise-management.module').then(
            (m) => m.NoiseManagementModule
          ),
      },
      {
        path: 'user-logging',
        loadChildren: () =>
          import("@ace/ace").then(
            (m) => m.UserLoggingModule,
          )
      },
      {
        path: 'channel-management',
        loadChildren: () =>
          import('./layouts/channel-management/channel-management.module').then(
            (m) => m.ChannelManagementModule
          ),
      },
      {
        path: 'out-of-scope',
        loadChildren: () =>
          import('./layouts/out-of-scope/out-of-scope.module').then(
            (m) => m.OutOfScopeModule
          ),
      },
      {
        path: 'session-drop-off',
        loadChildren: () =>
          import('./layouts/session-drop-off/session-drop-off.module').then(
            (m) => m.SessionDropOffModule
          ),
      },
      {
        path: 'faq-management',
        loadChildren: () =>
          import('./layouts/faq-management/faq-management.module').then(
            (m) => m.FaqManagementModule
          ),
      },
      {
        path: 'default-questions',
        loadChildren: () =>
          import('./layouts/default-questions/default-questions.module').then(
            (m) => m.DefaultQuestionsModule
          ),
      },
      {
        path: 'knowledge-intake',
        loadChildren: () =>
        import('./layouts/knowledge-intake/knowledge-intake.module').then(
          (m) => m.KnowledgeIntakeModule
        ),
      },
      {
        path: 'context-management',
        loadChildren: () =>
          import('./layouts/context-management/context-management.module').then(
            (m) => m.ContextManagementModule
          ),
      },
      {
        // Usage limits and resets. The backend restricts every route behind this page to
        // ROLE_ADMIN, so a non-administrator who reaches the URL gets an empty page and 403s
        // rather than a working screen.
        path: 'usage-management',
        loadChildren: () =>
          import('./layouts/usage-management/usage-management.module').then(
            (m) => m.UsageManagementModule
          ),
      },
      {
        path: 'landing-list/:moduleId',
        loadComponent: () =>
          import(
            '@ace/ace'
          ).then((m) => m.DynamicLandingListComponent),
      },
      {
        path: ':moduleId/form/:action',
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                '@ace/ace'
              ).then((m) => m.FormHandlingComponent),
          },
          {
            path: '',
            loadComponent: () =>
              import(
                '@ace/ace'
              ).then((m) => m.FormHandlingComponent),
          },
        ],
      },
      {
        path: 'error-management',
        loadChildren: () =>
          import('./layouts/error-management/error-management.module').then(
            (m) => m.ErrorManagementModule
          ),
      },
      {
        path: 'audit-trail',
        loadChildren: () =>
          import('@ace/ace').then(
            (m) => m.AuditTrailModule
          ),
      },

      ], canActivate: [AuthserviceService]
  },
  // { path: '**', redirectTo: 'login', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
